import { PublicPageKey } from '../models/public-page.model';

/**
 * Where the public pages are mounted. They live OUTSIDE the app shell (top bar + footer only), so
 * every link to them is an absolute path. Change these to re-mount the feature — nothing else
 * hard-codes a path.
 */
export const PUBLIC_PAGE_PATHS: Record<PublicPageKey, string> = {
  privacy: '/privacy',
  terms: '/terms',
  support: '/support',
  documentation: '/documentation',
};

export interface PublicNavLink {
  label: string;
  path: string;
}

/** The public shell's top-bar nav — also the footer's link row, so both stay in step. */
export const PUBLIC_NAV_LINKS: readonly PublicNavLink[] = [
  { label: 'Privacy', path: PUBLIC_PAGE_PATHS.privacy },
  { label: 'Terms', path: PUBLIC_PAGE_PATHS.terms },
  { label: 'Support', path: PUBLIC_PAGE_PATHS.support },
  { label: 'Documentation', path: PUBLIC_PAGE_PATHS.documentation },
];
